import { Joi, objectSchemaOf, actionCreator } from '../helpers';
import { SENTIENCE_INPUT } from './topics';

export const UTTERANCE = 'SENTIENCE/UTTERANCE' as const;

// originally ISendMessageToBotParams in functions
export interface IUtterancePayload {
  message: string;
  messageId: string;
  conversationId: string;
  consoleId: string;
  organisationId: string;
  recordingId: string;
  timestamp: number;
  engine?: string;
}

export const utterancePayload = objectSchemaOf<IUtterancePayload>({
  message: Joi.string().required(),
  messageId: Joi.string().required(),
  conversationId: Joi.string().required(),
  consoleId: Joi.string().required(),
  organisationId: Joi.string().required(),
  recordingId: Joi.string().required(),
  timestamp: Joi.number().required(),
  engine: Joi.string().optional(),
});

export interface IUtteranceAction {
  type: typeof UTTERANCE;
  payload: IUtterancePayload;
}

export const utteranceActionSchema = objectSchemaOf<IUtteranceAction>({
  type: Joi.string().valid(UTTERANCE).required(),
  payload: utterancePayload.required(),
});

export const utterance = actionCreator({
  schema: utteranceActionSchema,
  topic: SENTIENCE_INPUT,
  type: UTTERANCE,
});
